<template>
  <q-dialog v-model="isOpen" persistent transition-show="scale" transition-hide="scale" @hide="onDialogHide" :maximized="isFullscreen">
    <q-card :class="[
      'secondary-modal-card',
      'scrollbar__wrapper',
      { 'fullscreen-modal': isFullscreen },
      { 'secondary-modal-card_narrow': appStore.secondaryModal.type === 'CreatePlacementType' }
    ]">
      <q-card-section class="secondary-modal-header">
        <div class="text-h6 secondary-modal-title">
          {{ modalData?.title || '' }}
        </div>
        <q-btn class="close-btn" @click="closeModal()" flat dense round>
          <img src="/img/icons/close.svg" style="width: 13px;" alt="close" />
        </q-btn>
      </q-card-section>

      <q-card-section :class="['secondary-modal-content', { 'fullscreen-content': isFullscreen }]">
        <component v-if="CurrentSecondaryModalComponent" :is="CurrentSecondaryModalComponent" :data="modalData"
          :closeModal="closeModal" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useAppStore } from '@/services/store/app'


import CreateMaterialSet from './modals/create-material-set/index.vue'
import CreateWorkset from './modals/create-workset/index.vue'
import CreateConstructiveGroupSet from './modals/create-constructive-group-set/index.vue'
import SelectSbsProject from './modals/select-sbs-project/index.vue'
import CreatePlacementType from './modals/create-placement-type/index.vue'
import AddMaterialCertificate from './modals/add-material-certificate/index.vue'
import AddLaboratoryAct from './modals/add-laboratory-act/index.vue'
import ConfirmModal from '@/components/modal/modals/modal-types/ConfirmModal'
import ChangeProjectDate from '@/components/modal/modals/change-project-date/index.vue'
import ExecListCreateDocument from '@/components/modal/modals/exec-list-create-document'

const appStore = useAppStore()

const secondaryModalComponents = {
  CREATE_MATERIAL_SET: CreateMaterialSet,
  CreateWorkset: CreateWorkset,
  CreateConstructiveGroupSet: CreateConstructiveGroupSet,
  SelectSbsProject: SelectSbsProject,
  CreatePlacementType: CreatePlacementType,
  AddMaterialCertificate: AddMaterialCertificate,
  AddLaboratoryAct: AddLaboratoryAct,
  ConfirmModal: ConfirmModal,
  ChangeProjectDate: ChangeProjectDate,
  ExecListCreateDocument: ExecListCreateDocument,
}

const isOpen = computed({
  get: () => appStore.secondaryModal.show,
  set: (value) => {
    if (!value) {
      appStore.closeSecondaryModal()
    }
  }
})

const modalData = computed(() => appStore.secondaryModal.data)

const CurrentSecondaryModalComponent = computed(() => {
  return secondaryModalComponents[appStore.secondaryModal.type] || null
})

const isFullscreen = computed(() => {
  return appStore.secondaryModal.type === 'SelectSbsProject'
})

function closeModal(type) {
  const currentType = appStore.secondaryModal.type
  const onClose = appStore.secondaryModal?.data?.onClose

  if (type === currentType || type === undefined) {
    if (onClose) onClose()
    appStore.closeSecondaryModal()
  }
}

function onDialogHide() {
  const onClose = appStore.secondaryModal?.data?.onClose
  if (onClose) onClose()
}


watch(
  () => appStore.modal.show,
  (newShow, oldShow) => {

    if (newShow && !oldShow && appStore.secondaryModal.show) {
      appStore.closeSecondaryModal()
    }

    if (!newShow && appStore.secondaryModal.show) {
      appStore.closeSecondaryModal()
    }
  }
)
</script>

<style lang="scss" scoped>
.secondary-modal-card {
  border-radius: 8px;

  &.fullscreen-modal {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }

  &_narrow {
    max-width: 500px;
    width: 90vw;
    
    @media (max-width: 576px) {
      width: 95vw;
    }
  }
}

.secondary-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: white;
  position: sticky;
  top: 0;
  z-index: 1;
}

.secondary-modal-title {
  font-weight: 600;
  color: #1a1a1a;
}

.close-btn {
  color: #666;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.secondary-modal-content {
  padding: 15px;
  padding-top: 5px;
  padding-bottom: 20px;
  max-height: calc(600px - 80px);

  &.fullscreen-content {
    padding: 0;
    max-height: calc(100vh - 80px);
    height: calc(100vh - 80px);
  }
}
</style>
